export default "__VITE_ASSET__J1aayxZn__"